import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import Icon from './Icon';

const SmallAv = ({ u, size = 28 }) => (
  <div style={{
    width: size, height: size, borderRadius: '50%', overflow: 'hidden', flexShrink: 0,
    border: '1px solid rgba(255,255,255,.12)',
  }}>
    {u?.avatar
      ? <img src={u.avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      : <div style={{
          width: '100%', height: '100%', background: 'rgba(225,6,0,.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 900, fontSize: size * 0.4, color: '#e10600',
        }}>
          {u?.username?.[0]?.toUpperCase() ?? '?'}
        </div>
    }
  </div>
);

const GAME_LABELS = { lightspeed: 'LightSpeed', cirquiz: 'CirQuiz', podiumquiz: 'PodiumQuiz' };

const RivalryCard = ({ opponent, game }) => {
  const { user } = useAuth();
  const [rival, setRival] = useState(null);

  useEffect(() => {
    if (!opponent?._id) return;
    api.get('/challenges/rivalries')
      .then(r => {
        const found = (r.data || []).find(rv => String(rv.opponent._id) === String(opponent._id));
        setRival(found || null);
      })
      .catch(() => {});
  }, [opponent?._id]);

  if (!rival || !user || !opponent) return null;

  const stats  = game && rival.byGame?.[game] ? rival.byGame[game] : rival;
  const myWins  = stats.wins  ?? 0;
  const oppWins = stats.losses ?? 0;
  const draws   = stats.draws  ?? 0;
  const total   = myWins + oppWins + draws;

  if (total === 0) return null;

  const meAhead = myWins > oppWins;
  const tied    = myWins === oppWins;
  const myPct   = Math.round((myWins / total) * 100);
  const oppPct  = Math.round((oppWins / total) * 100);

  const myColor  = meAhead ? '#22c55e' : tied ? '#a1a1aa' : '#71717a';
  const oppColor = !meAhead && !tied ? '#22c55e' : tied ? '#a1a1aa' : '#71717a';

  return (
    <div className="mt-3 rounded-xl px-3 py-3"
      style={{ border: '1px solid rgba(255,255,255,.07)', background: 'rgba(255,255,255,.02)' }}>

      <p style={{
        fontSize: 9, fontWeight: 700, color: '#52525b',
        textTransform: 'uppercase', letterSpacing: 2, marginBottom: 10,
      }}>
        <Icon name="sword" size={9} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 4 }} />
        Rivalité{game ? ` · ${GAME_LABELS[game] ?? game}` : ''}
      </p>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* Me */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, flex: 1 }}>
          <SmallAv u={user} />
          <p style={{ color: '#d4d4d8', fontSize: 10, fontWeight: 700, margin: 0, textAlign: 'center', maxWidth: 60, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.username}
          </p>
          <p style={{ fontSize: 22, fontWeight: 900, color: myColor, lineHeight: 1, margin: 0 }}>{myWins}</p>
          <p style={{ fontSize: 8, color: '#52525b', margin: 0 }}>victoire{myWins !== 1 ? 's' : ''}</p>
        </div>

        {/* Centre stats */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flexShrink: 0, minWidth: 40 }}>
          <p style={{ color: '#3f3f46', fontSize: 11, fontWeight: 900, margin: 0 }}>VS</p>
          {draws > 0 && <p style={{ fontSize: 8, color: '#52525b', margin: 0 }}>{draws}N</p>}
          <p style={{ fontSize: 8, color: '#3f3f46', margin: '2px 0 0' }}>{total} défi{total > 1 ? 's' : ''}</p>
        </div>

        {/* Opponent */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, flex: 1 }}>
          <SmallAv u={opponent} />
          <p style={{ color: '#a1a1aa', fontSize: 10, fontWeight: 700, margin: 0, textAlign: 'center', maxWidth: 60, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {opponent?.username}
          </p>
          <p style={{ fontSize: 22, fontWeight: 900, color: oppColor, lineHeight: 1, margin: 0 }}>{oppWins}</p>
          <p style={{ fontSize: 8, color: '#52525b', margin: 0 }}>victoire{oppWins !== 1 ? 's' : ''}</p>
        </div>
      </div>

      {/* Bar */}
      <div style={{ marginTop: 10, height: 4, borderRadius: 4, background: '#27272a', overflow: 'hidden', display: 'flex' }}>
        <div style={{
          height: '100%', background: meAhead ? '#22c55e' : '#e10600',
          width: `${myPct}%`, transition: 'width .5s ease',
        }} />
        {draws > 0 && <div style={{ height: '100%', background: '#52525b', width: `${100 - myPct - oppPct}%` }} />}
        <div style={{
          height: '100%', background: !meAhead && !tied ? '#22c55e' : '#e10600',
          width: `${oppPct}%`,
        }} />
      </div>
    </div>
  );
};

export default RivalryCard;

